import React from 'react';
import './CallContext.css';
import { FaRegClock } from 'react-icons/fa';

const CallContext = () => {
  const contextItems = [
    {
      id: 1,
      title: 'Load #LTX-4521 - Tracking Update Needed',
      tags: ['Urgent', 'In Transit'],
      time: '1 hour ago',
      details: 'Chicago, IL → Dallas, TX · Pickup: Today 2:00 PM',
    },
    {
      id: 2,
      title: 'Load #LTX-4489 - Detention Time Claim',
      tags: ['Action Required', 'Pending Review'],
      time: '2 days ago',
      details: 'Phoenix, AZ → Seattle, WA · Delivered: 2 days ago',
    },
    {
      id: 3,
      title: 'Open Invoice #INV-9821',
      tags: ['Follow-up', 'Overdue'],
      time: '6 days ago',
      details: 'Payment due: Nov 15, 2024 · Amount: $2,450.00',
    },
  ];

  const getTagClass = (tag) => {
    switch (tag.toLowerCase()) {
      case 'urgent': return 'tag-urgent';
      case 'in transit': return 'tag-in-transit';
      case 'action required': return 'tag-action-required';
      case 'pending review': return 'tag-pending-review';
      case 'follow-up': return 'tag-follow-up';
      case 'overdue': return 'tag-overdue';
      default: return 'tag-default';
    }
  };

  return (
    <div className="call-context-section">
      <h4>
        <span className="trending-icon">↗</span>
        Here are the most likely things they’re calling about
      </h4>
      <div className="context-list">
        {contextItems.map(item => (
          <div key={item.id} className="context-item">
            <div className="context-header">
              <div className="context-tags">
                {item.tags.map(tag => (
                  <span key={tag} className={`tag ${getTagClass(tag)}`}>{tag}</span>
                ))}
              </div>
              <span className="context-time"><FaRegClock /> {item.time}</span>
            </div>
            <p className="context-title">{item.title}</p>
            <p className="context-details">{item.details}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CallContext;